<template>
  <div>
    <el-popover placement="bottom-start" trigger="hover">
      <div class="but">
        <el-button
          v-permit:remove="buttonPermissionsArr[0]"
          size="small"
          type="primary"
          @click="onExport(1)"
        >{{ $t('receivablePayable.Export') }}</el-button>
        <el-button
          v-permit:remove="buttonPermissionsArr[1]"
          style="margin-top: 10px;margin-left: 0;"
          size="small"
          type="primary"
          @click="dialogVisible = true"
        >{{ $t('receivablePayable.按单号导出') }}
        </el-button>
        <el-button
          v-permit:remove="buttonPermissionsArr[2]"
          style="margin-top: 10px;margin-left: 0;"
          size="small"
          type="primary"
          @click="onExport(2)"
        >{{ $t('receivablePayable.SheinExport') }}
        </el-button>
        <el-button
          v-permit:remove="buttonPermissionsArr[3]"
          style="margin-top: 10px;margin-left: 0;"
          size="small"
          type="primary"
          @click="onExport(3)"
        >{{ $t('receivablePayable.SheinTailgatePartyBillExport') }}
        </el-button>
        <el-button
          v-permit:remove="buttonPermissionsArr[4]"
          style="margin-top: 10px;margin-left: 0;"
          size="small"
          type="primary"
          @click="orderVisible = true"
        >{{ $t('receivablePayable.exportOrdersByDate') }}
        </el-button>
      </div>

      <template #reference>
        <el-button
          v-permit:remove="butPermit"
          size="small"
        >{{ $t('receivablePayable.Export') }}
        </el-button>
      </template>
    </el-popover>

    <el-dialog
      :title="$t('receivablePayable.tips')"
      :visible.sync="dialogVisible"
      width="500px"
    >
      <!--下载模板-->
      <el-button
        icon="el-icon-download"
        size="small"
        type="primary"
        @click="onDownloadTemplate"
      >
        {{ $t('basicData.DownloadTheTemplate') }}
      </el-button>
      <!--导入修改费用-->
      <upload-excel
        :on-success="importLogistics"
        :but-name="$t('spareNumberPoo.ImportData')"
        style="display: inline-block;margin-left: 20px;"
      />
    </el-dialog>

    <!--    日期导出-->
    <order-export
      :visible="orderVisible"
      @change="orderVisible = false"
    />
  </div>
</template>

<script>
import {
  apiExportCustomerBills,
  apiShineExportCustomerBills,
  apiShineExportTailgateBills
} from '@/api/finance/receivables';
import { goResourceTaskList } from '@/utils/goExportList.js';
import uploadExcel from '@/components/UploadExcel';
import { downloadTemplate, parseTemplate } from './utils';
import { apiByServiceCode } from '@/api/finance/receivableManagementSite';

export default {
  components: {
    uploadExcel,
    orderExport: () => import('./orderExport.vue')
  },

  props: {
    // 搜索
    queryForm: {
      type: Object,
      required: true
    },
    // 表格显示的栏目
    currentColumns: {
      type: Array,
      required: true
    },

    // 勾选的
    selectData: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      dialogVisible: false,
      orderVisible: false,
      buttonPermissionsArr: [
        'btn:aRGenerationNew:export',
        'btn:aRGenerationNew:NumberExport',
        'btn:aRGenerationNew:SheinExport',
        'btn:aRGenerationNew:SheinTailgateExport',
        'btn:aRGenerationNew:orderExport'
      ]
    };
  },

  computed: {
    // 按钮是否有权限
    butPermit() {
      // 有导出权限
      if (this.buttonPermissions.includes(this.buttonPermissionsArr[0])) {
        return this.buttonPermissionsArr[0];
      }

      // 有按单号导出权限
      if (this.buttonPermissions.includes(this.buttonPermissionsArr[1])) {
        return this.buttonPermissionsArr[1];
      }

      // 有shein揽收对账单导出权限
      if (this.buttonPermissions.includes(this.buttonPermissionsArr[2])) {
        return this.buttonPermissionsArr[2];
      }

      // 有shein尾派导出权限
      if (this.buttonPermissions.includes(this.buttonPermissionsArr[3])) {
        return this.buttonPermissionsArr[3];
      }

      // 订单导出权限
      if (this.buttonPermissions.includes(this.buttonPermissionsArr[4])) {
        return this.buttonPermissionsArr[4];
      }

      return '';
    }
  },

  created() {
    this.buttonPermissions = this.$store.getters.button_permissions;
  },

  methods: {
    // 获取表头 及多选id
    getHeadId() {
      const label = [];
      const prop = [];
      const ids = this.selectData.map(item => item.id);
      this.currentColumns.forEach(item => {
        if (item.prop !== 'customerAlias') {
          prop.push(item.prop);
          label.push(item.label);
        }
      });
      return { prop, label, ids };
    },

    /**
     * type 1:导出  2:希音揽收对账单 3:希音尾派导出
     */
    onExport(type) {
      const { prop, label, ids } = this.getHeadId();

      const param = {
        ...this.queryForm.params,
        ids
      };
      if (type === 1) {
        param.fieldList = prop;
        param.headList = label;
      } else {
        if (param.businessType !== '') {
          if (type === 2 && param.businessType !== 1) {
            return this.$message.warning(this.$t('basicData.PleaseSelectTheDataOfBusinessTypeAsCollection'));
          }
          if (type === 3 && param.businessType !== 0) {
            return this.$message.warning(this.$t('basicData.PleaseSelectTheDataOfBusinessTypeAsCourier'));
          }
        } else {
          return this.$message.warning(this.$t('basicData.PleaseSelectTheBusinessTypeFirst'));
        }
      }
      const fn = {
        1: apiExportCustomerBills,
        2: apiShineExportCustomerBills,
        3: apiShineExportTailgateBills
      };
      // const fn = type === 1 ? apiExportCustomerBills : apiShineExportCustomerBills;
      fn[type](param).then(() => {
        goResourceTaskList();
      }).catch(err => {
        console.error(err);
      });
    },

    // 下载模板
    onDownloadTemplate() {
      downloadTemplate();
    },

    // 导入修改费用
    importLogistics(arr) {
      const list = parseTemplate(arr[0].results.splice(2));
      // console.log(list);

      const { prop, label } = this.getHeadId();

      const param = {
        fieldList: prop,
        headList: label,
        conditions: list
      };
      apiByServiceCode(param).then(() => {
        this.$message.success(this.$t('basicData.TheOperationSucceeded'));
        return goResourceTaskList();
      }).then(code => {
        if (!code) return;
        this.dialogVisible = false;
      }).catch(err => {
        console.error(err);
      });
    }
  }
};
</script>

<style scoped>
.but {
  display: flex;
  align-items:flex-start;
  justify-content: center;
  flex-direction: column;
}
</style>
